import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { useTranslation } from "react-i18next";
import { TreeSelectComponent } from '../../Components/TreeSelectComponent';
import { InputText } from 'primereact/inputtext';
import PaymentScheduleActions from "../../Redux/transition/payment-schedule/payment-schedule.reducer";
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { useDispatch, useSelector } from 'react-redux';
import CustomToast from '../../Components/CustomToast';
import { GlobalSearch } from '../../Components/GlobalSearch';
import { Tooltip } from 'primereact/tooltip';
import { amountDisplayPerPolicy, formatBillingPeriodText, policyDisplay } from '../../Components/CleanInputs';
import { Dropdown } from 'primereact/dropdown';

const RecordPayment = (props) => {
    const { state, setState, calenderDateFormat, countryCurrency, membershipId, callBack, defMembership } = props;

    const { t } = useTranslation("common");
    const recordPaymentRef = useRef(null);

    const [notes, setNotes] = useState('')
    const [reference, setReference] = useState('')
    const [inputAmount, setInputAmount] = useState('');
    const [mode, setMode] = useState(null);
    const [calendarDates, setCalendarDates] = useState(null);
    const [showErr, setShowErr] = useState(false);
    const [toastTrigger, setToastTrigger] = useState(false);
    const [recordClicked, setRecordClicked] = useState(false);
    const [toastData, setToastData] = useState({ summary: '', severity: '', detail: '', life: 0 });
    const [bcId, setBcId] = useState(null);
    const [recordState, setRecordState] = useState({
        filteredCustomers: [],
        exactFilteredBusinessCustomers: [],
        selectedCustomerId: null,
        isCustomerSelected: false,
        verificationStatus: null,
        fetchingVerifRecord: true,
        businessCustomerRecord: {},
        query: ""
    })

    //redux states
    const { errorRecordingExternalPaymentBySubscriber, recordingExternalPaymentBySubscriber, externalPaymentBySubscription,
        recordingExternalPaymentBySubscription, errorRecordingExternalPaymentBySubscription, externalPaymentBySubscriber } = useSelector((state) => state.paymentSchedules);

    //redux calls
    const dispatch = useDispatch();
    const recordExternalPaymentBySubscriber = useCallback((planId, membershipId, formData) => { dispatch(PaymentScheduleActions.externallyRecordSubscriberRequest(planId, membershipId, formData)) }, [dispatch]);
    const recordExternalPaymentBySubscription = useCallback((subscriptionId, membershipId, formData) => { dispatch(PaymentScheduleActions.externallyRecordSubscriptionRequest(subscriptionId, membershipId, formData)) }, [dispatch]);

    const showInputField = (state.treePlanSelected && ["FIXED", "FLEXIBLE"].includes(state.treePlanSelected.policy))
        || (state.plan && ["FIXED", "FLEXIBLE"].includes(state.plan.policy)) || state.currentSubscription?.subscriber?.plan;
    const disableButtonConditions = showErr || !calendarDates || !inputAmount || recordClicked || !mode;
    const getToday = new Date();


    useEffect(() => {
        if (!recordingExternalPaymentBySubscriber && externalPaymentBySubscriber && recordClicked) {
            showToast(t("success"), "success", t("plan.success_mark"))
        }
        if (!recordingExternalPaymentBySubscription && externalPaymentBySubscription && recordClicked) {
            showToast(t("success"), "success", t("plan.success_mark"))
        }

        if (!recordingExternalPaymentBySubscriber && errorRecordingExternalPaymentBySubscriber && recordClicked) {
            showToast(t("err"), "error", t("plan.mark_failure"), 5000)
        }
        if (!recordingExternalPaymentBySubscription && errorRecordingExternalPaymentBySubscription && recordClicked) {
            showToast(t("err"), "error", t("plan.mark_failure"), 5000)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordingExternalPaymentBySubscriber, recordingExternalPaymentBySubscription, externalPaymentBySubscription,
        errorRecordingExternalPaymentBySubscription, externalPaymentBySubscriber, errorRecordingExternalPaymentBySubscriber,
        recordClicked])


    useEffect(() => {
        if (recordState?.businessCustomerRecord) {
            setBcId(recordState.businessCustomerRecord.id);
        }

    }, [recordState.businessCustomerRecord])

    const showToast = (summary = "", severity = "", detail = "", life = 3000) => {
        setToastData({ summary, severity, detail, life });
        setToastTrigger(true)
    }

    function hidePopup() {
        setState(prev => ({
            ...prev,
            showRecordPopup: false
        }));

        setState(prev => ({
            ...prev,
            currentSubscriber: null,
            currentSubscription: null,
            treePlanSelectedKey: null,
            oneOffOnly: false,
            onSubscriptionsTable: false
        }))
        setInputAmount('');
        setMode(null);
        setReference("")
        if (state.plan) {
            callBack();
        }
    }

    const clearFields = () => {
        setRecordState(prev => ({
            ...prev,
            query: ""
        }))
        setInputAmount('');
        setCalendarDates(null);
        setNotes('');
        setMode(null)
        setReference("")
    }

    const handleAmtChange = function (e) {
        let val = e?.target.value;
        val = val.replace(/[^0-9.]/g, '');

        if (val === '') {
            setInputAmount('');
            setShowErr(false);
            return;
        }

        val = val.replace(/(\..*?)\..*/g, '$1');
        const match = val.match(/^\d*(\.?\d{0,2})/);
        const cleanValue = match ? match[0] : '';

        const numericValue = parseFloat(cleanValue);
        const minAmount = 1;
        const maxAmount = 10000;

        if (numericValue < minAmount || numericValue > maxAmount) {
            setInputAmount(cleanValue);
            setShowErr(true);
        } else {
            setInputAmount(cleanValue);
            setShowErr(false);
        }
    }

    const modeOptions = [{ name: "Cash", alias: "CASH" },
    { name: "Bank Transfer", alias: "BANK_TRANSFER" },
    { name: "Cheque", alias: "CHEQUE" },
    { name: "Mobile Money", alias: "MOBILE_MONEY" }
    ]

    const handleDateChange = (e) => {
        const dateValue = e?.target.value;
        setCalendarDates(dateValue)
    }

    const handleNoteChange = (e) => {
        const value = e?.target.value;
        setNotes(value);
    }

    const handleRefChange = (e) => {
        const value = e?.target.value;
        setReference(value);
    }

    const modeChange = (e) => {
        const value = e?.value;
        setMode(value);
    }

    const onSubmit = () => {
        const businessCustomerId = state.currentSubscriber ? state.currentSubscriber.businessCustomer.id : state.customerRecord?.id;
        const planId = state.treePlanSelected?.id;
        // const subscriptionReference = state.currentSubscription?.subscriber?.subscriberReference;
        const subscriptionId = state.currentSubscription?.id;

        const subscriberData = {
            receivedOn: calendarDates,
            amount: inputAmount,
            bcId: businessCustomerId,
            reference: reference || null,
            notes,
            // externalMode: mode?.alias
            mode: mode?.alias
        }

        const subscriptionData = {
            receivedOn: calendarDates,
            amount: inputAmount,
            reference: reference || null,
            bcId: bcId || state.currentSubscription?.businessCustomer?.id,
            notes,
            mode: mode?.alias
        }

        const dataOnPlanDetails = {
            receivedOn: calendarDates,
            amount: inputAmount,
            bcId,
            reference: reference || null,
            notes,
            mode: mode?.alias
        }

        setRecordClicked(true);

        if (state.onSubscriptionsTable) {
            //this runs on the subscriber details (table)
            recordExternalPaymentBySubscription(subscriptionId, membershipId, subscriptionData);
            return;
        } else if (state.plan) {
            //this runs on the plan details
            recordExternalPaymentBySubscriber(state.plan?.id, membershipId, dataOnPlanDetails);
            return;
        } else {
            //this runs on subscriber listings and subscriber details (action menu)
            recordExternalPaymentBySubscriber(planId, membershipId, subscriberData);
        }
    }

    return (
        <div>
            <CustomToast
                {...toastData}
                trigger={toastTrigger}
                handleActionsAfterToast={() => {
                    setToastTrigger(false);
                    setRecordClicked(false);
                    clearFields();
                    if (!state.plan) {
                        // Only if not on plan Details, make these calls
                        callBack();
                        hidePopup();
                    }
                }}
                handleActionsAfterErrorToast={() => {
                    setToastTrigger(false);
                    setRecordClicked(false);
                }}
            />

            <Dialog
                visible={state.showRecordPopup}
                header={t("business_customers.record_external_pay")}
                style={{ width: "350px" }}
                onHide={hidePopup}
            >
                <section className='p-3'>
                    {/* state.plan is only present when recording payment on the plan detail screen */}
                    {state.plan ?
                        <>
                            <div className="title flex">
                                <p className="labels">{t("plan.select_sub")}</p>
                                <p className="isterik">*</p>
                            </div>
                            <GlobalSearch
                                state={recordState}
                                setState={setRecordState}
                                defMembership={defMembership}
                                globalQuery={false}
                                globalBorderWidth={{ minWidth: "22rem", border: "none" }}
                            />
                        </> : state.currentSubscription ?
                            <>
                                <div>
                                    <p className='mb-0 reveknew_gray'>{state.currentSubscription?.subscriber?.plan.name}</p>
                                    <p className='mb-1 reveknew_black text-sm'>{state.currentSubscription?.subscriber?.plan.description}</p>
                                    <div className='flex gap-2'>
                                        <p className='mb-0'>{policyDisplay(state.currentSubscription?.subscriber?.plan)}</p>
                                        <p className='mb-0 account_name'>{amountDisplayPerPolicy(defMembership?.business?.currency, state.currentSubscription?.subscriber?.plan)}</p>
                                        <p className='mb-0 reveknew_red'>{formatBillingPeriodText(state.currentSubscription?.subscriber?.plan.billingPeriod)}</p>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <div className="title flex">
                                    <p className="labels">{t("plan.select_title")}</p>
                                    <p className="isterik">*</p>
                                </div>
                                <TreeSelectComponent
                                    ref={recordPaymentRef}
                                    state={state}
                                    setState={setState}
                                    showClear={true}
                                    showOneOffOnly={state.oneOffOnly}
                                    showRecurring={state.onSubscriptionsTable}
                                    placeholder={t('plan.select_title')}
                                    className="w-full payments-activity-dropdown"
                                />
                                <div>
                                    <Tooltip
                                        target=".target-icon"
                                        className="planInfoTooltip"
                                    >
                                        <div className="planInfo-div pb-0">
                                            {state.treePlanSelected?.description ? (
                                                <span className="planInfoDesc">
                                                    {state.treePlanSelected?.description}
                                                </span>
                                            ) : null}

                                            {(state.treePlanSelected?.policy) ?
                                                <div className="mb-1">
                                                    {<div>
                                                        <span className="text-left policy">
                                                            {state.treePlanSelected?.policy === "FIXED" ? t("products.fixed_billing").toUpperCase()
                                                                : t('billing', { val: state.treePlanSelected?.policy })}
                                                        </span>
                                                        <div>
                                                        </div>
                                                    </div>
                                                    }
                                                </div> : null}


                                            <div style={{ marginBottom: "0.5rem" }}>
                                                {/* Amount info */}
                                                <div style={{ margin: "0rem 0.5rem 0rem 0rem" }}>
                                                    <span className='label'>{amountDisplayPerPolicy(defMembership?.business?.currency, state.treePlanSelected)}</span>
                                                </div>

                                                {/* Billing info */}
                                                <div className="mb-0.5">
                                                    <span className="planInfoBillingPeriod">
                                                        {t(`product.${(state.treePlanSelected?.billingPeriod)?.toLowerCase()}`)}
                                                    </span>
                                                </div>
                                            </div>

                                        </div>
                                    </Tooltip>

                                    {state.treePlanSelected && <div className="mt-2">
                                        <i
                                            className="target-icon pi pi-info-circle"
                                            data-pr-position="bottom"
                                            style={{ fontSize: "12px", cursor: "pointer", color: "#495057", fontWeight: "600" }}
                                        ></i>
                                        <span style={{ fontSize: "12px", color: "#495057", paddingLeft: "4px", fontWeight: "600" }}>
                                            {t("invitation.planDetailsInfo")}
                                        </span>
                                    </div>}
                                </div>
                            </>}

                    {(showInputField) && <div>
                        <div className="title flex mt-4">
                            <p className="labels">{t("plan.enter_amount")}</p>
                            <p className="isterik">*</p>
                        </div>
                        <InputText
                            style={{ height: "3rem" }}
                            placeholder={t("plan.amount")}
                            value={inputAmount}
                            onChange={(e) => handleAmtChange(e)}
                            maxLength={5}
                        />
                        {showErr && <p className='character_errors'>{t("plan.max_allowed", { currency: countryCurrency })}</p>}


                        <div className="title flex mt-4">
                            <p className="labels">{t("plan.mode")}</p>
                            <p className="isterik">*</p>
                        </div>
                        <Dropdown
                            style={{ height: "3rem" }}
                            placeholder={t("plan.choose")}
                            value={mode}
                            onChange={(e) => modeChange(e)}
                            options={modeOptions}
                            optionLabel='name'
                            className='text-left items-center col-12 segment_drop'
                            id='segment_dialog'
                        />
                    </div>
                    }
                    {/* calender */}
                    <div className="title flex mt-4">
                        <p className="labels">{t("plan.payment_date")}</p>
                        <p className="isterik">*</p>
                    </div>
                    <Calendar
                        id="startDate invite-calender"
                        name="startDate"
                        value={calendarDates}
                        maxDate={getToday}
                        readOnlyInput
                        inputMode=""
                        dateFormat={calenderDateFormat}
                        onChange={(e) => handleDateChange(e)}
                        showIcon
                        placeholder={t("plan.date_select")}
                        className="p-datepicker-header invite-calender datepicker"
                    />

                    {/* reference */}
                    <div className="title flex mt-4">
                        <p className="labels">{t("plan.ref")}</p>
                    </div>
                    <InputText
                        style={{ height: "3rem" }}
                        placeholder={t("plan.add_ref")}
                        value={reference}
                        onChange={(e) => handleRefChange(e)}
                    />

                    {/* notes */}
                    <div className="title flex mt-4">
                        <p className="labels">{t("plan.note")}</p>
                    </div>
                    <InputText
                        style={{ height: "3rem" }}
                        placeholder={t("plan.add_note")}
                        value={notes}
                        onChange={(e) => handleNoteChange(e)}
                    />


                    <div className='flex justify-content-end mt-5'>
                        <Button
                            id={disableButtonConditions && "disableButtonLook"}
                            style={{ width: "auto", backgroundColor: "#d0021b" }}
                            label={t("plan.record_button")}
                            disabled={disableButtonConditions}
                            onClick={() => onSubmit()}
                            loading={recordingExternalPaymentBySubscriber || recordingExternalPaymentBySubscription}
                        />
                    </div>
                </section>
            </Dialog>
        </div>
    )
}
export default RecordPayment;
